module.exports = __webpack_public_path__ + "img/01.69798d46.jpg";